import { observer } from 'mobx-react';
import { TabPanel, TabView } from 'primereact/tabview';
import { useStore } from 'hooks/useStore';

import classes from './targetMarketPlan.module.scss';

import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import ConceptDetailsSection from 'screens/FDP/components/ConceptDetails';
import TMSTableLoadingSkeleton from './components/TMSTableLoadingSkeleton';
import TMSViewTable from './components/TMSViewTable';
import SalesPlanViewTable from './components/SalesPlanViewTable';
import SalesPlanLoadingSkeleton from './components/SalesPlanLoadingSkeleton';

import { useTargetMarketShate } from './useTargetMarketShare';
import { useSalesPlan } from './useSalesPlan';
import { useTMSViewTable } from './components/TMSViewTable/useTMSViewTable';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { salesPlanAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import NotesSection from 'screens/FDPScreen/components/NotesSection';

const TargetMarketPlan = () => {
  const {
    MSPlanStore: {
      msplanPlanningPeriod,
      tmsViewData,
      salesplanViewData,
      salesplanPlanningPeriod,
      contractDetails,
      tmsNotesData,
    },
  } = useStore();
  const {
    tabIndex,
    userModulesRoles,
    // salesplanstatus,
    planBtnLabel,
    isTMSNotesDataLoading,
    isSalesPlanStatusLoading,
    setTabIndex,
  } = useTargetMarketShate();
  const { isTMSPlanViewDataLoading, conceptDetails, isConceptLoading } = useTMSViewTable();
  const { isSalesPlanDataLoading } = useSalesPlan();

  return (
    <div
      className={`${classes.targetMarketContainer} ${
        conceptDetails?.gfc === 0 && !isConceptLoading && classes.displayNone
      }`}
    >
      <div className={classes.planningContainer}>
        <div className={classes.tmsHeading}>
          <h2>Sales Plan Forecast</h2>
        </div>
        {isConceptLoading ? (
          <ConceptDetailsSkeleton />
        ) : (
          <ConceptDetailsSection
            path={`edit?gfc=${conceptDetails?.gfc}`}
            label={planBtnLabel}
            loading={isSalesPlanStatusLoading}
            isDisabled={
              // (salesplanstatus.MarketShareAdjustmentStatus &&
              //   salesplanstatus.SalesPlanAdjustmentStatus) ||
              isSalesPlanStatusLoading ||
              !checkIfFunctionalityEnabled(
                salesPlanAllowedRoles.createNewSalesPlan,
                userModulesRoles.fdp,
                userModulesRoles
              )
            }
            conceptDetails={conceptDetails}
            contractDetails={contractDetails}
          />
        )}
      </div>

      <div style={{ display: 'flex', gap: '1rem' }}>
        <div
          style={{
            width: '90rem',
            borderRadius: '8px',
            flexGrow: '1',
          }}
        >
          <TabView scrollable tabIndex={tabIndex === true ? 0 : 1}>
            <TabPanel
              header={
                <div
                  onClick={() => setTabIndex()}
                  className={`
                ${tabIndex ? classes.headerSelected : classes.headerUnselected} ${classes.tabIndex}
                `}
                >
                  Market Share Plan
                </div>
              }
            >
              {isTMSPlanViewDataLoading ? (
                <TMSTableLoadingSkeleton />
              ) : tmsViewData.GFC !== 0 && msplanPlanningPeriod.length > 0 ? (
                <TMSViewTable />
              ) : (
                <div
                  style={{
                    height: '50rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem',
                  }}
                >
                  No Market Share Plan data available!
                </div>
              )}
            </TabPanel>
            <TabPanel
              header={
                <div
                  onClick={() => setTabIndex()}
                  className={`
                ${!tabIndex ? classes.headerSelected : classes.headerUnselected} ${classes.tabIndex}
                `}
                >
                  Sales Plan
                </div>
              }
            >
              {isSalesPlanDataLoading ? (
                <SalesPlanLoadingSkeleton />
              ) : salesplanViewData.GFC !== 0 && salesplanPlanningPeriod.length > 0 ? (
                <SalesPlanViewTable />
              ) : (
                <div
                  style={{
                    height: '50rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem',
                  }}
                >
                  No Sales Plan data available!
                </div>
              )}
            </TabPanel>
          </TabView>
        </div>
        <NotesSection
          mode="view"
          isNotesDataLoading={isConceptLoading || isTMSNotesDataLoading}
          notesData={tmsNotesData}
        />
      </div>
    </div>
  );
};

export default observer(TargetMarketPlan);
